import React, { useState, useEffect } from 'react';

import Category from '../modules/models/category';
import Subcategory from '../modules/models/subcategory';

import { trackView } from '../utils/googleAnalytics';

import NavBar from '../components/navBar';
import SearchBar from '../components/searchBar';
import Categories from '../components/categories';
import Footer from '../components/footer';

import CarbonAds from "react-carbon-ads";

const Home = (props: any) => {
    const [json, setJson] = useState<Category[]>(require('../modules/cheatsheet-v2.2.16.json'));
    const [cheatsheet, setCheatsheet] = useState<Category[]>(json);
    const [searchValue, setSearchValue] = useState('');

    useEffect(() => {
        trackView('/tools/tailwind-cheat-sheet/');
    }, []);

    const search = (event: any) => {
        const text: string = event.target.value;

        let newCheatsheet: Category[] = json.map((category: Category) => {
            return {
                ...category,
                'content': category.content.map((subcategory: Subcategory) => {
                    return {
                        ...subcategory,
                        // Si el texto de búsqueda existe en el título o la descripción se muestra toda la tabla, si no pues se filtra en ella
                        'table': subcategory.title.includes(text) || subcategory.description.includes(text) ? subcategory.table : subcategory.table.filter(tr => {
                            let isValid = false;

                            tr.forEach(td => {
                                if (!isValid) {
                                    isValid = td.includes(text);
                                }
                            });

                            return isValid;
                        }),
                    };
                }),
            };
        });

        setSearchValue(text);
        setCheatsheet(newCheatsheet);
    };

    const version = (event: any) => {
        const version: string = event.target.value;

        setJson(require('../modules/cheatsheet-' + version + '.json'));
        setCheatsheet(require('../modules/cheatsheet-' + version + '.json'));
        setSearchValue('');
    };

    return (
        <div className="bg-white dark:bg-gray-900">
            <NavBar />
            <div className="my-5 w-full max-w-8xl mx-auto px-4 lg:flex lg:justify-between lg:items-center lg:my-6">
                <div className="lg:w-1/2">
                    <h1 className="inline-block text-3xl font-extrabold text-gray-900 dark:text-white tracking-tight">Tailwind CSS Cheat Sheet</h1>
                    <p className="mt-1 text-lg text-gray-500 dark:text-gray-400 mb-3 lg:mb-0">Get started with this free tool to view and search for all the class names and CSS properties from the world's most popular utility-first CSS framework. Inspired by <a href="https://nerdcave.com/tailwind-cheat-sheet" rel="nofollow noreferrer noopener" target="_blank" className="text-blue-600 dark:text-blue-500 hover:underline">Nerdcave's original cheat sheet</a>.</p>
                </div>
                <CarbonAds carbonUrl="//cdn.carbonads.com/carbon.js?serve=CK7D4KQE&placement=flowbitedesign" />
            </div>
            <SearchBar searchValue={searchValue} search={search} version={version} />
            <Categories cheatsheet={cheatsheet} />
            <Footer />
        </div>
    );
}

export default Home;
